import { CardLabels } from '@productSearch/containers/SearchResultsContainer/utilities/getProductCardLabels';
import { ProductSearchMaterial } from '@productSearch/types';
import { isUnavailable } from '@productSearch/utils/helpers';

export function getAddToCardLabels(
  {
    isGeoRestricted,
    isProjectRestricted,
    isUnavailable,
  }: {
    isGeoRestricted?: boolean;
    isProjectRestricted?: boolean;
    isUnavailable?: boolean;
  },
  cardLabels: CardLabels,
): {
  addToCartLabel: string;
  addToCartHoverLabel: string;
  addToCartTooltipLabel?: string;
  outOfStockLabel?: string;
} {
  if (isUnavailable) {
    return {
      addToCartLabel: cardLabels.availabilityRestricted,
      addToCartHoverLabel: cardLabels.seeSimilarLabel,
      addToCartTooltipLabel: cardLabels.availabilityRestrictedTooltip,
      outOfStockLabel: '',
    };
  }

  if (isGeoRestricted) {
    return {
      addToCartLabel: cardLabels.geoRestricted,
      addToCartHoverLabel: cardLabels.seeSimilarLabel,
      addToCartTooltipLabel: cardLabels.geoRestrictedTooltip,
    };
  }
  if (isProjectRestricted) {
    return {
      addToCartLabel: cardLabels.projectRestricted,
      addToCartHoverLabel: cardLabels.seeSimilarLabel,
      addToCartTooltipLabel: cardLabels.projectRestrictedTooltip,
    };
  }

  return {
    addToCartLabel: cardLabels.addToCartLabel,
    addToCartHoverLabel: '',
    addToCartTooltipLabel: '',
  };
}

export const isRestricted = (product: ProductSearchMaterial) => {
  return (
    product.isProjectRestricted ||
    product.isGeoRestricted ||
    isUnavailable(product, product.entityId)
  );
};
